module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship-bg.5578c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship-bg.png
// module id = dhzd
// module chunks = 0